import { orderBy } from "lodash-es";

export const postSearchTermFilter = (result: any, scoreTreshhold: number) => {
  const { data } = result;

  const items: any = [];

  if (!data) {
    return [];
  }

  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const pageType = data[key];
      items.push(...pageType.items);
    }
  }

  const filteredItems = items?.filter((item: any) => {
    return item._score >= scoreTreshhold;
  });

  const sortedItems = orderBy(filteredItems, ["_score"], ["desc"]);

  return sortedItems;
};
